import React from 'react';
import { currencyFormatter } from '../../../../utils/services';
import './ActiveWonStackedBar.css';

/**
 * Una sola barra horizontal apilada: Won + Forecast + Lost.
 * Porcentajes sobre el total; montos solo en la leyenda. Lost no depende del filtro Status.
 */
function ActiveWonStackedBar({ activeAmount = 0, wonAmount = 0, lostAmount = 0 }) {
  const total = activeAmount + wonAmount + lostAmount;
  const wonPct = total > 0 ? (wonAmount / total) * 100 : 0;
  const activePct = total > 0 ? (activeAmount / total) * 100 : 0;
  const lostPct = total > 0 ? (lostAmount / total) * 100 : 0;

  return (
    <div className="active-won-stacked-bar">
      <div className="active-won-stacked-bar__bar">
        <div
          className="active-won-stacked-bar__segment active-won-stacked-bar__segment--won"
          style={{ width: `${wonPct}%` }}
        >
          {wonPct >= 5 && (
            <span className="active-won-stacked-bar__pct">{wonPct.toFixed(0)}%</span>
          )}
        </div>
        <div
          className="active-won-stacked-bar__segment active-won-stacked-bar__segment--active"
          style={{ width: `${activePct}%` }}
        >
          {activePct >= 5 && (
            <span className="active-won-stacked-bar__pct">{activePct.toFixed(0)}%</span>
          )}
        </div>
        <div
          className="active-won-stacked-bar__segment active-won-stacked-bar__segment--lost"
          style={{ width: `${lostPct}%` }}
        >
          {lostPct >= 5 && (
            <span className="active-won-stacked-bar__pct">{lostPct.toFixed(0)}%</span>
          )}
        </div>
      </div>
      <div className="active-won-stacked-bar__legend">
        <span className="active-won-stacked-bar__legend-item">
          <span className="active-won-stacked-bar__legend-color active-won-stacked-bar__legend-color--won" />
          Won: {currencyFormatter.format(wonAmount)}
        </span>
        <span className="active-won-stacked-bar__legend-item">
          <span className="active-won-stacked-bar__legend-color active-won-stacked-bar__legend-color--active" />
          Forecast: {currencyFormatter.format(activeAmount)}
        </span>
        <span className="active-won-stacked-bar__legend-item">
          <span className="active-won-stacked-bar__legend-color active-won-stacked-bar__legend-color--lost" />
          Lost: {currencyFormatter.format(lostAmount)}
        </span>
        
      </div>
    </div>
  );
}

export default ActiveWonStackedBar;
